module.exports = __webpack_public_path__ + "media/images/illustrations/starworks-star-light-1e9ac063f0c938510a116bb88e711c36.svg";